import { getSettings, updateSettings } from '@/api/http-settings.js'
import { errorHandler } from '@/api/utils/http-helpers'

const SETTINGS_LOAD = 'SETTINGS_LOAD'
const SETTINGS_SAVE = 'SETTINGS_SAVE'
const START = 'START'
const END = 'END'
const ERROR = 'ERROR'
const CLOSE_ERROR = 'CLOSE_ERROR'
const SET_SAVING = 'SET_SAVING'
const SET_DB_DISCONNECTED = 'SET_DB_DISCONNECTED'
const SET_STATUS_SOCKET_SERVER = 'SET_STATUS_SOCKET_SERVER'
const SET_PATTERN_VALIDATION_ENABLED = 'SET_PATTERN_VALIDATION_ENABLED'
const SET_PATTERN_GENERATION_ENABLED = 'SET_PATTERN_GENERATION_ENABLED'

const initialState = {
  settings: {},
  isLoading: false,
  isloaded: false,
  error: false,
  isSaving: false,
  isDbDisconnected: false,
  statusSocketServer: 'unknown',
  isPatternValidationEnabled: false,
  isPatternGenerationEnabled: false
}

const state = { ...initialState }

// Getters
const getters = {
  settings (state) {
    return state.settings
  },
  error (state) {
    return state.error
  },
  isSaving (state) {
    return state.isSaving
  },
  isDbDisconnected (state) {
    return state.isDbDisconnected
  },
  statusSocketServer (state) {
    return state.statusSocketServer
  },
  isPatternValidationEnabled (state) {
    return state.isPatternValidationEnabled
  },
  isPatternGenerationEnabled (state) {
    return state.isPatternGenerationEnabled
  }
}

// Actions
const actions = {
  async loadSettings ({ commit }) {
    commit('START')
    await getSettings()
      .then((response) => {
        // console.log('loadSettings - response: ', JSON.stringify(response))
        const isDbEnabled = response.dbParams != null && response.dbParams.enabled && response.dbParams.host != null
        if (isDbEnabled) {
          commit('SET_DB_DISCONNECTED', false)
        }
        const validationEnabled = isDbEnabled && response.ppParams != null && response.ppParams.validationEnabled && response.ppParams.host != null
        const patternGenEnabled = isDbEnabled && response.pgParams != null && response.pgParams.enabled && response.pgParams.host != null
        commit('SET_PATTERN_VALIDATION_ENABLED', validationEnabled)
        commit('SET_PATTERN_GENERATION_ENABLED', patternGenEnabled)
        commit('SETTINGS_LOAD', response)
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
        commit('ERROR')
        commit('END')
      })
  },

  async updateSettings ({ commit }, payload) {
    commit('START')
    commit('SET_SAVING', true)
    await updateSettings(payload)
      .then((response) => {
        if (payload.dbParams != null &&
          (response != null && response.dbParams != null) &&
          payload.dbParams.enabled !== response.dbParams.enabled) {
          commit('ERROR')
        }
        const dbEnabled = response.dbParams != null && response.dbParams.enabled
        const validationEnabled = dbEnabled && response.ppParams.validationEnabled && response.ppParams.host != null
        const patternGenEnabled = dbEnabled && response.pgParams.enabled && response.pgParams.host != null
        commit('SET_PATTERN_VALIDATION_ENABLED', validationEnabled)
        commit('SET_PATTERN_GENERATION_ENABLED', patternGenEnabled)
        commit('SETTINGS_SAVE', response)
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        console.error(error)
        commit('ERROR')
      }).finally(() => {
        commit('END')
        commit('SET_SAVING', false)
      })
  },

  closeError ({ commit }) {
    commit('CLOSE_ERROR')
  },

  setDbDisconnected ({ commit }, value) {
    // console.log('setDbDisconnected: ', value)
    commit('SET_DB_DISCONNECTED', value)
  },

  setStatusSocketServer ({ commit }, value) {
    // console.log('setStatusSocketServer: ', value)
    commit('SET_STATUS_SOCKET_SERVER', value)
  }
}

// Mutations
const mutations = {
  [START] (state) {
    state.isloaded = false
    state.isLoading = true
  },

  [END] (state) {
    state.isLoading = false
    state.isloaded = true
  },

  [SETTINGS_LOAD] (state, payload) {
    state.settings = Object.assign({}, payload)
  },

  [SETTINGS_SAVE] (state, payload) {
    state.settings = Object.assign({}, state.settings, payload)
  },

  [ERROR] (state) {
    state.error = true
  },

  [CLOSE_ERROR] (state) {
    state.error = false
  },

  [SET_SAVING] (state, value) {
    state.isSaving = value
  },

  [SET_DB_DISCONNECTED] (state, value) {
    state.isDbDisconnected = value
  },

  [SET_STATUS_SOCKET_SERVER] (state, value) {
    state.statusSocketServer = value
  },

  [SET_PATTERN_VALIDATION_ENABLED] (state, value) {
    state.isPatternValidationEnabled = value
    if (!value) {
      state.statusSocketServer = 'unknown'
    }
  },

  [SET_PATTERN_GENERATION_ENABLED] (state, value) {
    state.isPatternGenerationEnabled = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
